import { Button, Typography } from '@uigovpe/components';
import { Skeleton } from './Skeleton';

interface PageHeaderProps {
  eyebrow?: string;
  title?: string;
  titleLoading?: boolean;
  description?: string;
  onBack?: () => void;
  backLabel?: string;
}

export function PageHeader({
  eyebrow,
  title,
  titleLoading,
  description,
  onBack,
  backLabel = 'Voltar',
}: PageHeaderProps) {
  return (
    <header className="cd-page-header">
      {eyebrow && (
        <Typography variant="span" size="sm" className="cd-page-header__eyebrow">
          {eyebrow}
        </Typography>
      )}
      <div className="cd-page-header__row">
        {titleLoading ? (
          <Skeleton width="14rem" height="1.75rem" />
        ) : (
          <Typography variant="h1" fontWeight="bold" size="xl">
            {title}
          </Typography>
        )}
        {onBack && (
          <Button
            label={backLabel}
            icon="pi pi-arrow-left"
            outlined
            className="cd-page-header__back"
            onClick={onBack}
          />
        )}
      </div>
      {description && (
        <Typography variant="p" size="default" className="cd-page-header__description">
          {description}
        </Typography>
      )}
    </header>
  );
}
